export const BRACKET_TRANSFORM_OPTIONS = {
  minScale: 0.5,
  initialScale: 1,
  maxScale: 1,
  alignmentAnimationSizeY: 0,
  alignmentAnimationSizeX: 0,
  defaultSeedWidth: 352,
};
